module.exports = __webpack_public_path__ + "static/media/snowy-2.ac29f12c.svg";